export { PLUGIN_KEY, PLUGIN_PRIORITY, CollapsibleColumns } from "./collapsibleColumns.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/collapsibleColumns/index.mjs
// module id = 1254
// module chunks = 1